import gql from 'graphql-tag'

export const FillerMaterialStandardsFetch = gql`
  query FillerMaterialStandardsFetchQuery {
    filler_material_standards {
      id
      name
      description
    }
  }
`

export const createFillerMaterialMutation = gql`
  mutation createFillerMaterial($standard_id: Int!, $trade_name: String, $classification: [String]) {
    createFillerMaterial(standard_id: $standard_id, trade_name: $trade_name, classification: $classification) {
      filler_material {
        id
        name
      }
      errors
    }
  }
`
export const createBaseMaterialMutation = gql`
  mutation createBaseMaterial($designation_name: String!, $group: String, $standard: String, $standardization: String!) {
    createBaseMaterial(designation_name: $designation_name, group: $group, standard: $standard, standardization: $standardization) {
      base_material {
        id
        name
        designation_name
        standardization
      }
      errors
    }
  }
`
export const createGasTypeMutation = gql`
  mutation createGasType($name: String!, $description: String) {
    createGasType(name: $name, description: $description) {
      gas_type {
        id
        name
        description
      }
      errors
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Dictionary/mutations.js